import {
  DynamicObjectInput,
  type DynamicObjectInputProps,
} from "$routes/_lib/dynamic-form-fields/dynamic-form-fields";
import type { ReactElement } from "react";
import { useController, useFormContext } from "react-hook-form";

/**
 * Used to register dynamic object inputs prior to registering individual inputs
 */
const RhfDynamicObjectInput = (
  props: DynamicObjectInputProps,
): ReactElement => {
  const { name } = props;
  const { control, getValues } = useFormContext();
  const values = getValues(name);

  useController({
    name,
    control,
    defaultValue: values,
  });

  return <DynamicObjectInput {...props} />;
};

export default RhfDynamicObjectInput;
